var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  style: {
    cursor: "pointer"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9292AF",
  d: "M16.68 3.322a4.504 4.504 0 0 0-6.374 0L8.286 5.34 9.35 6.403l2.02-2.019c1.12-1.12 3.012-1.24 4.25 0 1.239 1.24 1.12 3.13 0 4.25l-2.02 2.02 1.065 1.064L16.683 9.7a4.51 4.51 0 0 0-.002-6.377M8.638 15.618c-1.121 1.121-3.013 1.24-4.25 0-1.24-1.24-1.121-3.129 0-4.25L6.405 9.35 5.341 8.285l-2.02 2.018a4.504 4.504 0 0 0 0 6.376 4.506 4.506 0 0 0 6.376 0l2.02-2.019-1.064-1.063zM4.757 3.697a.167.167 0 0 0-.235 0l-.825.825a.167.167 0 0 0 0 .235l11.55 11.551c.065.065.171.065.236 0l.825-.825a.167.167 0 0 0 0-.236z"
})));
export default SvgLinkOff;